import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "../mock";

const Testimonials = () => {
  const [index, setIndex] = useState(0);
  const total = TESTIMONIALS.length;
  const prev = () => setIndex((i) => (i - 1 + total) % total);
  const next = () => setIndex((i) => (i + 1) % total);
  const t = TESTIMONIALS[index];

  return (
    <section className="bg-[#faf7f2] py-24">
      <div className="max-w-[860px] mx-auto px-5 text-center">
        <p className="text-[12px] tracking-[0.28em] uppercase text-[#b8935f] mb-3">Testimonials</p>
        <h2 className="font-display text-[32px] md:text-[40px] font-300 text-[#2b2b2b] mb-12">
          What Our Clients Say
        </h2>

        <div className="relative">
          <Quote size={48} className="text-[#b8935f]/25 mx-auto mb-6" />
          <blockquote className="font-display text-[20px] md:text-[24px] font-300 leading-relaxed text-[#3a3a3a] min-h-[180px] flex items-center justify-center">
            “{t.quote}”
          </blockquote>
          <p className="mt-8 text-[13px] tracking-[0.18em] uppercase text-[#b8935f]">{t.name}</p>

          <div className="flex items-center justify-center gap-4 mt-10">
            <button onClick={prev} aria-label="Previous" className="w-11 h-11 rounded-full border border-[#e2d8c8] flex items-center justify-center text-[#8a7a63] hover:bg-[#b8935f] hover:text-white hover:border-[#b8935f] transition-colors">
              <ChevronLeft size={20} />
            </button>
            <div className="flex gap-2">
              {TESTIMONIALS.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`h-2 rounded-full transition-all ${i === index ? "w-6 bg-[#b8935f]" : "w-2 bg-[#d8cdbb]"}`}
                  aria-label={`Go to testimonial ${i + 1}`}
                />
              ))}
            </div>
            <button onClick={next} aria-label="Next" className="w-11 h-11 rounded-full border border-[#e2d8c8] flex items-center justify-center text-[#8a7a63] hover:bg-[#b8935f] hover:text-white hover:border-[#b8935f] transition-colors">
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
